import React from 'react';

// Collapsible section with title + italic summary line + chevron that
// rotates 90deg when open. Controlled component — caller owns the `open`
// boolean and supplies onToggle. Extracted verbatim from
// prototypes/campaign-creation-prototype.jsx lines 2690-2744.
export const Expander = ({ title, summary, open, onToggle, children, theme }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  return (
    <div style={{
      background: c.bgCardSolid,
      border: `1px solid ${c.borderLight}`,
      borderRadius: 8,
      overflow: 'hidden',
    }}>
      <button
        onClick={onToggle}
        aria-expanded={open}
        style={{
          width: '100%',
          padding: '12px 16px',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 12,
          textAlign: 'left',
          color: c.textPrimary,
        }}
      >
        <span style={{
          fontSize: '0.8rem',
          color: c.accentLight,
          transition: 'transform 180ms ease',
          transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
          display: 'inline-block',
          flex: '0 0 auto',
        }}>▶</span>
        <span style={{
          fontFamily: t.headingFamily,
          fontSize: '0.95rem',
          fontWeight: 600,
          color: c.textPrimary,
          letterSpacing: '0.02em',
        }}>{title}</span>
        {summary && (
          <span style={{
            fontFamily: t.fontFamily,
            fontSize: '0.78rem',
            color: c.textMuted,
            fontStyle: 'italic',
            flex: 1,
          }}>· {summary}</span>
        )}
      </button>
      {open && (
        <div style={{
          padding: '4px 16px 16px',
          borderTop: `1px solid ${c.borderLight}`,
        }}>{children}</div>
      )}
    </div>
  );
};
